export const provideCacheTagsFromRelevantAddresses = (chainId, relevantAddresses, tag) => {
    if (relevantAddresses.tokens.length) {
        return relevantAddresses.tokens
            .map((tokenAddress) => relevantAddresses.accounts.map((accountAddress) => ({
            type: tag,
            id: `${chainId}_${tokenAddress}_${accountAddress}`,
        })))
            .flat();
    }
    else if (relevantAddresses.accounts.length) {
        return relevantAddresses.accounts.map((accountAddress) => ({
            type: tag,
            id: `${chainId}_${accountAddress}`,
        }));
    }
    else {
        return [
            {
                type: tag,
                id: `${chainId}`,
            },
        ];
    }
};
//# sourceMappingURL=provideCacheTagsFromRelevantAddresses.js.map